import { SubtleMonochromeLink } from '@liveauctioneers/hammer-ui-core/link';
import { BodyPrimary } from '@liveauctioneers/hammer-ui-core/text';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { useItemOrPriceResultLink } from '@/hooks/useItemOrPriceResultLink';
import { useAppSelector } from '@/redux/hooks';
import {
    getItemSummaryLotNumber,
    getItemSummarySEOExcluded,
    getItemSummaryTitle,
} from '@/redux/modules/item/summary/itemSummary.selectors';
import noop from '@/utils/noop';

import { LINE_CLAMP_CLASS } from '../../constants/lineClampClasses.constant';

type ItemCardTextProps = {
    className?: string;
    isHovered?: boolean;
    itemId: number;
    lineCount?: number;
    onMouseEnter?: () => void;
    onMouseLeave?: () => void;
    onNavigate?: () => void;
    showLotNumber?: boolean;
    testid?: string;
};

export const hoverStyles = 'text-link-hover underline';

export default function ItemCardTitle({
    className,
    isHovered = false,
    itemId,
    lineCount = 2,
    onMouseEnter = noop,
    onMouseLeave = noop,
    onNavigate,
    showLotNumber = false,
    testid,
}: ItemCardTextProps) {
    const title = useAppSelector((state) => getItemSummaryTitle(state, itemId));
    const lotNumber = useAppSelector((state) => getItemSummaryLotNumber(state, itemId));
    const isSEOExcluded = useAppSelector((state) => getItemSummarySEOExcluded(state, itemId));
    const itemUrl = useItemOrPriceResultLink(itemId, true);

    return (
        <SubtleMonochromeLink
            className={cn('group min-w-0 cursor-pointer capitalize no-underline', className)}
            href={itemUrl}
            onClick={() => {
                onNavigate?.();
            }}
            rel={isSEOExcluded ? 'nofollow' : ''}
        >
            <BodyPrimary
                className={cn(
                    LINE_CLAMP_CLASS[lineCount],
                    'overflow-hidden text-ellipsis group-hover:text-link-hover group-hover:underline',
                    isHovered && hoverStyles
                )}
                data-testid={testid}
                onMouseEnter={onMouseEnter}
                onMouseLeave={onMouseLeave}
            >
                {showLotNumber ? `${lotNumber}: ${title}` : title}
            </BodyPrimary>
        </SubtleMonochromeLink>
    );
}
